import { formatRingbaDate } from "./dateFormatter";

export const getByPath = (obj, path) => {
  if (!obj || !path) return undefined;
  try {
    return path.split(".").reduce((acc, part) => {
      if (acc == null) return undefined;
      return acc[part];
    }, obj);
  } catch (e) {
    return undefined;
  }
};

export const renderCell = (record, column) => {
  if (!record || !column) return "-";

  const key = typeof column === "string" ? column : column.key;
  if (!key) return "-";

  // Buyer IDs are opaque (e.g. "cmp5qnzrk02um07lcaf9maaib") - show the
  // human-readable buyer name when the source platform sent one, falling
  // back to the ID when it didn't.
  const value =
    key === "systemBuyerId"
      ? record.systemBuyerName || record.systemBuyerId
      : getByPath(record, key);

  if (value === undefined || value === null || value === "") return "-";

  if (key === "recordingUrl") {
    // Always play through the authenticated proxy so CallGrid's JSON-wrapped /
    // redirected / signed S3 URLs resolve to actual audio (never raw JSON).
    let href = value;
    if (record._id) {
      const base = process.env.REACT_APP_API_BASE || "";
      let token = null;
      try {
        token = localStorage.getItem("token");
      } catch (e) {
        token = null;
      }
      const qs = token ? `?token=${encodeURIComponent(token)}` : "";
      href = `${base}/api/calls/recording/${record._id}${qs}`;
    }
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-info"
        onClick={(e) => e.stopPropagation()}
      >
        <i className="bi bi-play-circle me-1" /> Play
      </a>
    );
  }

  if (key === "callTimestamp") return formatRingbaDate(value);

  if (typeof value === "object" && value !== null) {
    try {
      return JSON.stringify(value);
    } catch {
      return "[Object]";
    }
  }
 
  const str = String(value).trim();
  return column.truncate && str.length > 20 ? str.slice(0, 20) + "..." : str;
};
export const renderField = (label, value, type = 'text') => {
  if (type === 'date') value = formatRingbaDate(value);
  return (
    <div className="detail-field mb-2">
      <label style={{ fontWeight: 'bold' }}>{label}:</label>
      <span>{value || '-'}</span>
    </div>
  );
};


export const exportRecordForCSV = (record, columns) => {
  const row = {};
  (columns || []).forEach((col) => {
    const val = getByPath(record, col.key);
    row[col.label || col.key] = val == null ? "" : String(val);
  });
  return row;
};
